import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  dropdown: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '13px',
    color: '#2C2D3E',
    paddingRight: '7px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  selectList: {
    transform: 'translate(25px,45px)',
    '& .MuiMenuItem-root': {
      color: '#2C2D3E',
      padding: '0px 0px 0px 15px',
      fontSize: '13px',
      '&:focus': {
        color: '#2C2D3E',
      },
      '&:hover': {
        backgroundColor: '#CACAFC',
      },
    },
    '& .MuiMenu-list': {
      width: '112px',
      height: '90px',
    },
  },
  dropdownElement: {
    marginTop: '5px',
    width: '112px',
    height: '36px',
    fontSize: '14px',
  },
}));
